import React from 'react';
import { AddNewCustomerPage  } from 'components/pages';
export interface AddNewCustomerPageProps {};

const AddNewCustomer: React.FC<AddNewCustomerPageProps> = () => (
    <AddNewCustomerPage />
);

export default AddNewCustomer;